(() => {
  if (window.limitedEnamelBundleScriptInitialized) return;

  window.limitedEnamelBundleScriptInitialized = true;
  const instances = new Map();
  const rootSelector = '[data-limited-enamel-bundle]';

  const _fetch = window.__originalFetch || window.fetch.bind(window);

  const destroy = (sectionId) => {
    const instance = instances.get(sectionId);
    if (!instance) return;

    instance.destroy(true, true);
    instances.delete(sectionId);
  };

  const initialize = (root) => {
    const swiperElement = root.querySelector('[data-limited-enamel-bundle-swiper]');
    if (!swiperElement || typeof Swiper === 'undefined') return;

    const sectionId = swiperElement.dataset.sectionId;
    destroy(sectionId);

    const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;

    instances.set(sectionId, new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 450,
      watchOverflow: true,
      loop: slideCount > 1,
      grabCursor: slideCount > 1,
      navigation: {
        nextEl: root.querySelector('[data-slider-next]'),
        prevEl: root.querySelector('[data-slider-previous]')
      },
      pagination: {
        el: root.querySelector('[data-slider-pagination]'),
        clickable: true,
        bulletElement: 'button',
        bulletClass: 'limited-enamel-bundle__bullet',
        bulletActiveClass: 'is-active'
      },
      a11y: {
        prevSlideMessage: root.dataset.previousLabel,
        nextSlideMessage: root.dataset.nextLabel,
        paginationBulletMessage: root.dataset.paginationLabel
      }
    }));
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.(rootSelector)) initialize(scope);
    scope.querySelectorAll?.(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('larine:swiper', function () {
    initializeAll();
  });

  function showAddError(button, message) {
    const wrapper = button.closest('.limited-enamel-bundle__purchase')?.querySelector('[data-limited-enamel-bundle-error]');
    if (!wrapper) return;
    const text = wrapper.querySelector('.product-form__error-message');
    if (text) text.textContent = message;
    wrapper.hidden = false;
  }

  function hideAddError(button) {
    const wrapper = button.closest('.limited-enamel-bundle__purchase')?.querySelector('[data-limited-enamel-bundle-error]');
    if (wrapper) wrapper.hidden = true;
  }

  function getCheckoutUrl() {
    var raw = window.routes && window.routes.cart_url;
    if (typeof raw !== 'string' || !raw.length) return '/checkout';
    try {
      var u = new URL(raw, window.location.origin);
      u.pathname = u.pathname.replace(/\/cart\/?$/, '/checkout');
      return u.pathname + u.search;
    } catch (e) {
      return '/checkout';
    }
  }

  function wantsForceCheckoutRedirect(button) {
    var root = button.closest(rootSelector);
    return root?.getAttribute('data-force-checkout-redirect') === 'true';
  }

  function setAddLoading(button, isLoading) {
    if (isLoading) {
      button.dataset.originalLabel = button.querySelector('.limited-enamel-bundle__button-label')?.textContent || '';
      const label = button.querySelector('.limited-enamel-bundle__button-label');
      if (label) label.textContent = button.getAttribute('data-loading-text') || 'Adding...';
      button.disabled = true;
    } else {
      const label = button.querySelector('.limited-enamel-bundle__button-label');
      if (label && button.dataset.originalLabel) label.textContent = button.dataset.originalLabel;
      button.disabled = false;
    }
  }

  function parseGiftIds(button) {
    const raw = button.getAttribute('data-gift-ids') || '';
    if (!raw) return [];
    return raw
      .split(',')
      .map((id) => parseInt(id, 10))
      .filter((id) => id > 0);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-limited-enamel-bundle-add]');
    if (!button || button.disabled) return;

    const variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    const sellingPlanId = parseInt(button.getAttribute('data-selling-plan-id'), 10);
    const item = { id: variantId, quantity: 1 };
    if (sellingPlanId > 0) item.selling_plan = sellingPlanId;

    const giftIds = parseGiftIds(button).filter((id) => id !== variantId);
    const productId = parseInt(button.getAttribute('data-product-id'), 10);
    const giftProps = { _enamel_gift: '1' };
    if (productId > 0) giftProps._free_gift_for = String(productId);
    const items = [item];
    giftIds.forEach((id) => {
      items.push({ id, quantity: 1, properties: giftProps });
    });

    if (window.laborCtaDiscount && typeof window.laborCtaDiscount.remember === 'function') {
      window.laborCtaDiscount.remember({
        id: 'enamel',
        variantIds: [variantId],
        giftIds: giftIds,
        giftProp: '_enamel_gift',
        productId: productId > 0 ? productId : undefined,
      });
    }

    hideAddError(button);
    setAddLoading(button, true);

    _fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-drawer,cart-icon-bubble' }),
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) {
          throw new Error((data && (data.description || data.message)) || 'Could not add item to cart.');
        }
        if (data && data.sections && window.cartDrawerCustom && typeof window.cartDrawerCustom.applySections === 'function') {
          window.cartDrawerCustom.applySections(data.sections);
        }
        if (wantsForceCheckoutRedirect(button)) {
          window.location.href = getCheckoutUrl();
          return;
        }
        if (window.cartDrawerCustom && typeof window.cartDrawerCustom.open === 'function') {
          window.cartDrawerCustom.open(true);
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        }
      })
      .catch((err) => {
        showAddError(button, err.message || 'Could not add item to cart. Please try again.');
      })
      .finally(() => {
        setAddLoading(button, false);
      });
  });

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(rootSelector) ? event.target : event.target.querySelector?.(rootSelector);
    const sectionId = root?.querySelector('[data-limited-enamel-bundle-swiper]')?.dataset.sectionId;
    if (sectionId) destroy(sectionId);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('.limited-enamel-bundle__slide');
    const root = slide?.closest(rootSelector);
    const sectionId = root?.querySelector('[data-limited-enamel-bundle-swiper]')?.dataset.sectionId;
    const instance = sectionId ? instances.get(sectionId) : null;
    if (instance && slide) instance.slideTo([...slide.parentElement.children].indexOf(slide));
  });
})();
